import React, {useEffect, useRef}from "react";
import { useField } from '@unform/core';

export default function Input({ name, label, ...rest }){
  const inputRef = useRef(null)

  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref:inputRef.current,
      path: "value"
    })
  }, [fieldName, registerField])

  return (
    <>
      {label && <label htmlFor={fieldName}>{label} 
      {error && <span className="error" style={{color:"#f00"}}> {error}</span>}
      </label>}      
      <input className="inputglobal" ref={inputRef} {...rest} defaultValue={defaultValue}/>       
    </>  
  )
}